//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBM_CUSTOM_04 from './M_TBM_CUSTOM_04';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSearch1 } from './M_TBM_CUSTOM_04_Query';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_CUSTOM_04F(props) {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [fullUrl, setFullUrl] = useState();
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1);
  const [pageViewHeight, setPageViewHeight] = useState(0);
  const [renderPreview, setRenderPreview] = useState([]);
  const [pdfImages, setPdfImages] = useState([]);
  //#endregion

  // 스택형 뒤로가기로 변경: 확인 모달이 열린 동안 뒤로가기를 막음
  useBackStack({
    type: 'block',
    enabled: props.modalToggle2 === true,
    onBack: () => {},
  });

  //#region 이벤트
  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber]);

  //#endregion

  //#region 쿼리
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      const first = rows[0];

      const path = first?.filePath ?? first?.FILE_PATH;
      if (!path) {
        setFullUrl(null);
        setRenderPreview(null);
        return;
      }

      const ext = path.split('.').pop()?.toLowerCase();
      let finalPath = path;
      if (['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
        finalPath = path.replace(/\.[^/.]+$/, '.pdf');
      }

      const fileUrl = `${Global.file.useUrl}files/${finalPath}`;
      setFullUrl(fileUrl);

      const res = await fetch(fileUrl);
      const blob = await res.blob();
      const base64 = await blobToBase64(blob);
      setRenderPreview(base64);
    },
  });
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const onDocumentLoadSuccess = ({ numPages: total }) => {
    setNumPages(total);
  };

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      dispatch(CommonActions.setActiveStep(activeStep - 1));
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  //#endregion

  return (
    <M_TBM_CUSTOM_04
      userInfo={userInfo}
      lanList={lanInfo}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      pdfImages={pdfImages}
      setPdfImages={setPdfImages}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      check={props.check}
      setCheck={props.setCheck}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      ActiveButton={props.ActiveButton}
      getExtensionFromUrl={getExtensionFromUrl}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
      pdfFile={fullUrl}
    />
  );
}

export default M_TBM_CUSTOM_04F;
